import React from 'react';

import { RemoveSpaces } from '@/utils/functions';
import { IProduct } from '@/components/Products/ProductsInfo';
import { Icon } from '@/components/general';
import * as styled from './GridItem.styled';

interface IGridItem {
  item: IProduct;
}

export const GridItem: React.FC<IGridItem> = ({ item }) => (
  <styled.Box to={item.to ? item.to : `/${RemoveSpaces(item.title)}`}>
    <styled.IconBox>
      <Icon name={item.icon} color="#212133" />
    </styled.IconBox>
    <styled.Title>{item.title}</styled.Title>
    <styled.Description>{item.description}</styled.Description>
  </styled.Box>
);
